var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 325,
    viewBox: "0 0 325 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.281 135.979H284.374V135.417H162.499V189.583H239.029C227.864 221.115 197.863 243.75 162.499 243.75C117.628 243.75 81.2487 207.37 81.2487 162.5C81.2487 117.63 117.628 81.2502 162.499 81.2502C183.211 81.2502 202.054 89.0637 216.401 101.827L254.704 63.5241C230.518 40.984 198.167 27.0835 162.499 27.0835C87.7148 27.0835 27.082 87.7163 27.082 162.5C27.082 237.284 87.7148 297.917 162.499 297.917C237.283 297.917 297.915 237.284 297.915 162.5C297.915 153.42 296.981 144.557 295.281 135.979Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6953 99.4705L87.1865 132.099C99.225 102.294 128.38 81.2502 162.498 81.2502C183.21 81.2502 202.054 89.0637 216.401 101.827L254.704 63.5241C230.518 40.984 198.167 27.0835 162.498 27.0835C110.485 27.0835 65.3776 56.4486 42.6953 99.4705Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 297.916C197.478 297.916 229.26 284.53 253.29 262.762L211.379 227.297C197.326 237.984 180.155 243.764 162.5 243.75C127.278 243.75 97.3714 221.291 86.1047 189.949L41.9453 223.972C64.3568 267.827 109.87 297.916 162.5 297.916Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.283 135.978H284.375V135.417H162.5V189.583H239.031C233.69 204.59 224.07 217.704 211.358 227.303L211.379 227.29L253.29 262.756C250.324 265.45 297.917 230.208 297.917 162.5C297.917 153.42 296.982 144.557 295.283 135.978Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.b9c83b567d36d1fa982ca65e9ea340e9.svg";
export { ForwardRef as ReactComponent };